import { render, staticRenderFns } from "./BaseAction.vue?vue&type=template&id=2a1b2b84"
import script from "./BaseAction.vue?vue&type=script&lang=js"
export * from "./BaseAction.vue?vue&type=script&lang=js"
import style0 from "./BaseAction.vue?vue&type=style&index=0&id=2a1b2b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports